import ApplicationList from './list';
export default ApplicationList;
